<template>
  <div class="prediction-panel" v-if="decoratedSections.length">
    <!-- <h3 class="prediction-panel__title">预测参考</h3> -->
    <div
      v-for="sec in decoratedSections"
      :key="sec.sectionId"
      class="prediction-card"
    >
<!--      <div class="prediction-card__header">-->
<!--        <span class="prediction-card__name">{{gameLabel}} {{ sec.sectionName }}</span>-->
<!--        <span class="prediction-card__hit-rate" v-if="sec._hitRate != null">-->
<!--          近{{ sec._total }}中{{ sec._hits }}-->
<!--        </span>-->

<!--      </div>-->
      <div style="border: 8px double #ff9900; background: #009900; min-height: 40px; display: flex; align-items: center; justify-content: center;">
        <b><font face="微软夜黑" style="font-size: 18pt" color="#FFFFFF">{{gameLabel}} {{ sec.sectionName }}</font></b>
      </div>
      <div v-if="sectionDesc(sec)" class="prediction-card__desc">
<!--        <span class="prediction-card__desc-label">描述：</span>-->
        <span class="prediction-card__desc-text">{{ sectionDesc(sec) }}</span>
      </div>
      <div class="prediction-card__table-wrap">
        <table class="prediction-card__table">
          <tbody>
            <template v-for="(item, idx) in sec.items">
              <tr :key="idx" :class="[rowClass(item.resultHit), { 'item-row--divider': idx > 0 }]">
                <td class="item-head">
                  <span>第{{ periodShort(item.period) }}期</span>

                </td>
                <td class="col-content" v-html="highlightContent(item)"></td>
                <td class="col-result">
                  <span>
                    {{ item.resultText }}
                  </span>
                  <button
                      v-if="item.resultText === '开？00'"
                      type="button"
                      class="item-head__copy"
                      :class="{ 'item-head__copy--copied': copiedLine === copyKey(sec, idx) }"
                      @click="copyText(String(item.contentText || ''), copyKey(sec, idx))"
                  >{{ copiedLine === copyKey(sec, idx) ? '已复制' : '复制' }}</button>
                  </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThreeTable',
  props: {
    sections: { type: Array, default: () => [] },
    gameLabel: { type: String, default: '' },
    sectionDescs: { type: [Array, String], default: () => [] },
    start:{ type: Number, default: 0 },
    end:{ type: Number, default: 0 },
  },
  data() {
    return {
      copiedLine: null,
      copyTimerId: null
    }
  },
  beforeDestroy() {
    if (this.copyTimerId != null) {
      clearTimeout(this.copyTimerId)
      this.copyTimerId = null
    }
  },
  computed: {
    descMap() {
      const map = {}
      if (!Array.isArray(this.sectionDescs)) return map
      this.sectionDescs.forEach(it => {
        if (!it || !it.code) return
        const d = String(it.desc != null ? it.desc : (it.description || '')).trim()
        if (d) map[it.code] = d
      })
      return map
    },
    decoratedSections() {
      return this.sections.slice(this.start,this.end).map(sec => {
        const items = (sec.items || []).slice(0, 10)
        const hits = items.filter(it => it.resultHit === 1).length
        const decided = items.filter(it => it.resultHit != null).length
        return {
          ...sec,
          items,
          _hits: hits,
          _total: decided,
          _hitRate: decided > 0 ? Math.round((hits / decided) * 100) : null
        }
      })
    }
  },
  methods: {
    sectionDesc(sec) {
      if (!sec) return ''
      const direct = String(sec.desc != null ? sec.desc : (sec.description || '')).trim()
      if (direct) return direct
      if (typeof this.sectionDescs === 'string') return this.sectionDescs.trim()
      return (this.descMap[sec.code] || '').trim()
    },
    copyKey(sec, idx) {
      return sec.sectionId + '-' + idx
    },
    copyText(text, key) {
      const done = () => {
        this.copiedLine = key
        if (this.copyTimerId != null) clearTimeout(this.copyTimerId)
        this.copyTimerId = setTimeout(() => {
          this.copiedLine = null
          this.copyTimerId = null
        }, 3000)
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done))
      } else {
        this.fallbackCopy(text, done)
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        done()
      } catch (e) {
        // silent
      }
      document.body.removeChild(ta)
    },
    periodShort(period) {
      const s = String(period ?? '')
      return s.length > 4 ? s.slice(4) : s
    },
    escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    matchKeys(matchKey) {
      return String(matchKey || '')
        .split(/[,，]/)
        .map(k => this.escapeHtml(k.trim()))
        .filter(Boolean)
        .sort((a, b) => b.length - a.length)
    },
    highlightText(text, keys) {
      const escaped = this.escapeHtml(text)
      if (keys.length === 0) return escaped
      const pattern = keys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
      return escaped.replace(new RegExp(`(${pattern})`, 'g'), '<span class="hl">$1</span>')
    },
    highlightContent(item) {
      const keys = this.matchKeys(item.matchKey)
      const text = String(item.contentText || '')
      return this.highlightText(text, keys).replace(/\n/g, '<br>')
    },
    rowClass(hit) {
      if (hit === 1) return 'row--hit'
      if (hit === 0) return 'row--miss'
      return 'row--pending'
    },
    hitLabel(hit) {
      if (hit === 1) return '✓ 中'
      if (hit === 0) return '✗ 错'
      return '待'
    }
  }
}
</script>

<style scoped>
.prediction-panel {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0;
}
.prediction-panel__title {
  margin: 0 0 clamp(0.375rem, 2vw, 0.5rem);
  font-size: clamp(0.875rem, 3.4vw, 1rem);
  font-weight: 800;
  color: #153a6b;
  padding-left: 0.25rem;

}
.prediction-card {
  background: #fff;
  //border-radius: clamp(0.5rem, 2.5vw, 0.75rem);
  margin-bottom: clamp(0.375rem, 2vw, 0.5rem);
  box-shadow: 0 2px 8px rgba(30,107,214,0.08);
  overflow: hidden;
  border: 1px solid #000000;
}
.prediction-card__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: clamp(0.5rem, 2.5vw, 0.625rem) clamp(0.5rem, 2.5vw, 0.625rem);
  background: linear-gradient(180deg, #e8f3fc 0%, #dceaf8 100%);
}
.prediction-card__name {
  font-weight: 700;
  font-size: clamp(0.8125rem, 2.8vw, 0.875rem);
  color: #0d2d52;
}
.prediction-card__hit-rate {
  font-size: clamp(0.6875rem, 2.4vw, 0.75rem);
  color: #2e7d32;
  font-weight: 600;
}
.prediction-card__table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.prediction-card__desc {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.25rem 0.5rem;
  background: #fffdf0;
  border-bottom: 1px solid #f0e6c8;
  font-size: clamp(0.75rem, 2.6vw, 0.8125rem);
}
.prediction-card__desc-label {
  color: #d32f2f;
  font-weight: 700;
  white-space: nowrap;
}
.prediction-card__desc-text {
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: bold;
  word-break: break-all;
  white-space: pre-line;
}
.prediction-card__table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: clamp(0.8125rem, 2.8vw, 0.875rem);
  min-width: 320px;
}
.prediction-card__table td {
  padding: 0.3rem 0.35rem;
  text-align: center;
  //border-bottom: 1px solid #f0f4f8;
}
.col-period {
  color: #5a7a9a;
  width: 3.8rem;
}
.item-head {
  text-align: center;
  color: gray;
  font-weight: 600;
  font-size: 0.9rem;
  width: 6.5rem;
  white-space: nowrap;
  vertical-align: middle;
}
.item-row--divider td {
  border-top: 1px solid #ec8873;
}
.col-content {
  word-break: break-all;
  color: #000000;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
.col-result {
  color: red;
  width: 6rem;
  white-space: normal;
  word-break: break-all;
  text-align: center;
  font-weight: 600;
  vertical-align: middle;
  font-size: 1rem;
}
.col-result--empty {
  color: #ccc;
}
.item-head__copy {
  border: 1px solid #d58352;
  background: #fff;
  color: #df0e0e;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 1.5;
  padding: 0 0.6rem;
  cursor: pointer;
  display: block;
  margin: 0.2rem auto 0;
}
.item-head__copy--copied {
  border-color: #2e7d32;
  color: #2e7d32;
  background: #e8f5e9;
}
.row--hit { background: #f0fdf4; }
.row--hit .col-result { color: #2e7d32; font-weight: 600; }
.row--miss { background: #fff5f5; }
.row--miss .col-result { color: #e02020; font-weight: 600; }
.row--pending { color: #9e9e9e; }
.prediction-card__table ::v-deep .hl {
  color: #d32f2f;
  font-weight: 800;
  background: #ffeb3b;
  padding: 0 2px;
  border-radius: 2px;
}
</style>
